import { render, staticRenderFns } from "./serveBack.vue?vue&type=template&id=5fa16fcb&scoped=true&"
import script from "./serveBack.vue?vue&type=script&lang=js&"
export * from "./serveBack.vue?vue&type=script&lang=js&"
import style0 from "./serveBack.vue?vue&type=style&index=0&id=5fa16fcb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa16fcb",
  null
  
)

export default component.exports